import gql from "graphql-tag";

export const ScoreParts = gql`
  fragment ScoreParts on Score {
    value
    color
  }
`;
